__turbopack_context__.v({
  "accordionSlideOverwrite": "gameButton-module-scss-module__PVpW6a__accordionSlideOverwrite",
  "fadeIn": "gameButton-module-scss-module__PVpW6a__fadeIn",
  "fadeOut": "gameButton-module-scss-module__PVpW6a__fadeOut",
  "gameButton": "gameButton-module-scss-module__PVpW6a__gameButton",
  "scaleIn": "gameButton-module-scss-module__PVpW6a__scaleIn",
  "scaleOut": "gameButton-module-scss-module__PVpW6a__scaleOut",
  "zoomIn": "gameButton-module-scss-module__PVpW6a__zoomIn",
  "zoomOut": "gameButton-module-scss-module__PVpW6a__zoomOut",
});
